export default function prepare_rating (input) {
  input = parseInt(input)
  input = input > 0 || input <= 5
    ? input
    : 0

  return input.toString()
}


// WEBPACK FOOTER //
// ./src/api/prepare_rating.js